import * as Yup from 'yup';

export const transferToVesselsValidationSchema = Yup.object().shape({
  trackFinishedVariants: Yup.boolean().required(),
  variants: Yup.number().when('trackFinishedVariants', {
    is: true,
    then: Yup.array().of(
      Yup.object()
        .shape({
          quantity: Yup.number()
            .required('The quantity is required')
            .typeError('The quantity is required'),
          packagingCost: Yup.number().typeError('The packaging cost is required'),
          taxPerLitre: Yup.number().typeError('The tax per litre is required'),
          productVariantId: Yup.number()
            .required('The product variant is required')
            .typeError('The product variant is required')
        })
        .required()
    ),
    otherwise: Yup.array()
      .nullable(true)
      .required()
  })
});



// WEBPACK FOOTER //
// ./src/validation/transfer.js